import Icon from '../components/Icon.vue'

Icon.register({
  anchor: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M13 352c-10.7 0-16-12.9-8.5-20.5l67-67c4.7-4.7 12.3-4.7 17 0l67 67c7.6 7.6 2.2 20.5-8.5 20.5h-35.1c20.3 54.3 85.2 86.6 144.1 94v-190h-52c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h52v-5.5c-37.3-13.2-64-48.7-64-90.5 0-53.5 43.7-96.7 97.4-96 52.2 0.7 94.6 43.8 94.6 96 0 41.8-26.7 77.3-64 90.5v5.5h52c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-52v190c59.2-7.4 123.8-39.7 144.1-94h-35.1c-10.7 0-16-12.9-8.5-20.5l67-67c4.7-4.7 12.3-4.7 17 0l67 67c7.6 7.6 2.2 20.5-8.5 20.5h-32.4c-21.8 102.6-136.4 160-242.6 160-106.1 0-220.8-57.3-242.6-160h-32.4zM288 64c-17.6 0-32 14.4-32 32s14.4 32 32 32 32-14.4 32-32-14.4-32-32-32z'
      }
    ]
  }
})
